import {
  EventHandler,
  EventDispachter,
  filter,
  interval,
  ISink,
  map,
  nothing,
  Observable,
  pipe,
  share, skipWhile, take, fromEvent, subscribe, subject, switchMap, takeWhile
} from 'fastrx';
// const tick = new EventEmitter();
// setInterval(() => {
//   tick.emit('tick', Date.now());
// }, 10);
// const tick10msOb = interval(10);
const tick250msOb = pipe(interval(250), map(() => performance.now()), share());
export const mcInterval = (period: number): Observable<number> => sink => {
  let index = 0;
  const startTime = performance.now();
  pipe(
    tick250msOb,
    map(n => (n - startTime) / period >> 0),
    filter(i => (i != index ? (index = i, true) : false))
  )(sink);
};
export const mcTimeout = (period: number): Observable<number> => sink => {
  const startTime = performance.now();
  pipe(
    tick250msOb,
    skipWhile(n => n - startTime < period),
    take(1)
  )(sink);
};
// 缓存最新的数据，再次订阅后立即发出
export const cacheLast = <T>() => {
  let next = nothing;
  let cache: T;
  const OB = (sink: ISink<T>) => {
    sink.defer(() => (next = nothing));
    next = data => sink.next(data);
    if (cache) sink.next(cache);
  };
  return Object.assign(OB, {
    next(data: T) {
      next(data);
      cache = data;
    }
  });
};
// 事件代理，当事件源被替换时，可以取消之前的监听，重新自动添加监听
export class EventDelegate<N, T> {
  targetOb = subject<EventDispachter<N, T>>();
  changeTarget(target: EventDispachter<N, T>) {
    this.targetOb.next(target);
  }
  destroy() {
    this.targetOb.next(null);
  }
  on(event: N, handler: EventHandler<T>) {
    pipe(
      this.targetOb,
      takeWhile(t => t != null),
      switchMap(t => fromEvent(t, event)),
      subscribe(handler)
    );
    return this;
  }
}
export function abortable<T>(promise: Promise<T> | ((resolve: (value: T | PromiseLike<T>) => void, reject: (reason?: any) => void) => void), signal: AbortSignal, onReject?: (reason: any) => any): Promise<T> {
  const p = signal.aborted ? Promise.reject(signal.reason) : new Promise<T>((resolve, reject) => {
    signal.addEventListener('abort', () => reject(signal.reason), { once: true });
    if (typeof promise === 'function') promise(resolve, reject);
    else promise.then(resolve, reject);
  });
  return onReject ? p.catch(onReject) : p;
}
